<template>
  <v-row dense>
    <v-col lg="6" md="6" sm="12" cols="12" v-for="(type, typeIndex) in ['identity', 'residence']" :key="type">
      <v-card v-for="(data, index) in getDocuments(type)" :key="index" flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="listing-upload">
        <v-row no-gutters justify="space-between" align="center">
          <v-col cols="4">
            <v-card-title>Date & Time</v-card-title>
            <v-card-subtitle>{{ formatMySQLDate(data?.created_at) }}</v-card-subtitle>
          </v-col>
          
          <v-col cols="4">
            <v-card-title class="comment-title">Comment</v-card-title>
            <v-dialog transition="scale-transition" origin="center center" max-width="554" content-class="deposit-withdraw-popup" v-model="dialogs[`comment_${type}_${data?.id}`]">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text elevation="0" class="text-capitalize pa-0 see-details-btn" v-bind="attrs" v-on="on">See Details</v-btn>
              </template>
              <v-card class="rounded-0" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="closeDialog(`comment_${type}_${data?.id}`)" style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-card-title class="rounded-0">Comment</v-card-title>
                <ol style="list-style-type: none"><li>{{ data?.comment }}</li></ol>
              </v-card>
            </v-dialog>
          </v-col>

          <v-col cols="3">
            <v-card-title class="d-block">Status</v-card-title>
            <v-card-subtitle class="approved-text" :style="{ color: verificationColor(data?.status) }">
              {{ data?.status === 2 ? "Pending" : data?.status === 1 ? "Approved" : "Rejected" }}
            </v-card-subtitle>
          </v-col>

          <v-col cols="1">
            <v-dialog max-width="554" v-model="dialogs[`image_${type}_${data?.id}`]">
              <template v-slot:activator="{ on, attrs }">
                <v-btn elevation="0" v-bind="attrs" v-on="on" class="icon-btn" @click="openImagePreview(type, data)">
                  <v-img class="white--text align-end" :src="data?.document_url" width="40"></v-img>
                </v-btn>
              </template>
              <v-card class="rounded-0 bg-transparent" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                <v-btn icon :color="$vuetify.theme.dark ? '#F1F7FB' : '#172233'" @click="closeDialog(`image_${type}_${data?.id}`)" style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-img class="white--text align-end" :src="previewImages[type]"></v-img>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { PROFILE__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      dialogs: {},
      previewImages: {
        identity: "",
        residence: ""
      }
    };
  },

  computed: {
    ...mapState("profile", ["documentInfo"])
  },

  methods: {
    ...mapActions("profile", [ PROFILE__ACTIONS.FETCHDOCUMENTS ]),

    getDocuments(type) {
      return type === 'identity' 
        ? this.documentInfo?.identityVerificationDocuments 
        : this.documentInfo?.residenceVerificationDocuments;
    },

    formatMySQLDate(date) {
      if (!date) return '';
      const parsedDate = date instanceof Date ? date : new Date(date);
      if (isNaN(parsedDate.getTime())) return '';

      const day = parsedDate.getDate().toString().padStart(2, '0');
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
      const year = parsedDate.getFullYear();
      let hours = parsedDate.getHours();
      const minutes = parsedDate.getMinutes().toString().padStart(2, '0');
      const amPm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12 || 12;

      return `${day}.${month}.${year} - ${hours}:${minutes} ${amPm}`;
    },

    openImagePreview(type, data) {
      this.previewImages[type] = data?.document_url;
      this.$set(this.dialogs, `image_${type}_${data?.id}`, true);
    },

    closeDialog(dialogKey) {
      this.$set(this.dialogs, dialogKey, false);
      if (dialogKey.includes('image_')) {
        const type = dialogKey.includes('identity') ? 'identity' : 'residence';
        this.previewImages[type] = "";
      }
    },

    verificationColor(value) {
        if(!value) value = 0;

        let verification_color=""

        if (value === 1) {
          verification_color = "#039de9"
        } else if (value === 2) {
            verification_color = "#D19909"
        } else {
            verification_color = "#FF567F"
        }
          
        return verification_color;
    }
  },

  async mounted() {
    try {
      await this[PROFILE__ACTIONS.FETCHDOCUMENTS]();
    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  }
};
</script>